exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sales-reps ul{width:250px}.badge-optional-missing{background-color:#fdf5dd}.badge-mandatory-missing,.badge-optional-missing{color:#212529;border-radius:.125rem;display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline}.badge-mandatory-missing{background-color:#ffdcda}", ""]);

// exports
